import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconProfile: React.FC<IconProps> = ({ ...props }) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7ZM8 13C5.23858 13 3 15.2386 3 18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18C21 15.2386 18.7614 13 16 13H8Z"
        fill="#200E32"
      />
    </Icon>
  );
};

export default IconProfile;
